__turbopack_context__.v({
  "sizeSelect": "xr6zcW_sizeSelect",
});
